import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  label: {
    fontFamily: 'Source Sans Pro',
    color: theme.palette.text.primary,
    fontSize: '14px',
  },
})
